"use client";

import {
  Button,
  ColorSchemeScript,
  Container,
  Group,
  MantineProvider,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import * as Sentry from "@sentry/nextjs";
import { IconRefresh } from "@tabler/icons-react";
import { useEffect } from "react";
import ButtonSupport from "@/components/ButtonSupport";
import { resolver, theme } from "@/theme";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <head>
        <ColorSchemeScript defaultColorScheme="dark" />
      </head>
      <body>
        <MantineProvider
          theme={theme}
          defaultColorScheme="dark"
          cssVariablesResolver={resolver}
        >
          <Container size="md" py="xl">
            <Stack align="center" gap="lg">
              <Title order={1}>Something went wrong!</Title>
              <Text c="dimmed" size="lg" ta="center">
                We apologize for the inconvenience. Our team has been notified
                and is working to fix the issue.
              </Text>
              <Text size="sm" c="red">
                Global Error: {error.message}
              </Text>
              <Group>
                <Button
                  leftSection={<IconRefresh size={16} />}
                  onClick={() => reset()}
                  variant="filled"
                >
                  Try Again
                </Button>
                <ButtonSupport variant="light" />
              </Group>
            </Stack>
          </Container>
        </MantineProvider>
      </body>
    </html>
  );
}
